/**
 * The exact `error.message` values emitted alongside an `AbortError` when the user
 * deliberately cancels a native share (one per platform). Only these represent an
 * expected cancellation; every other `AbortError` (e.g. file-read aborts, "could not
 * connect to Web Share interface", "The operation was aborted.", "Share failed") is a
 * genuine failure and must not be silenced from either analytics or Sentry.
 *
 * @see https://change.atlassian.net/browse/CHANGE-93785
 * @see https://change.atlassian.net/browse/CHANGE-94562
 */
const SHARE_CANCELLATION_MESSAGES = [
	// iOS
	'Abort due to cancellation of share.',
	// Android
	'Share canceled',
];

/**
 * Returns true when `error` represents a deliberate user cancellation of a
 * `navigator.share()` call (dismissing the native share sheet), as opposed to a
 * genuine failure. Cancellations should not be tracked as failures and should not be
 * reported to Sentry.
 */
export function isShareCancellation(error: Error): boolean {
	return error.name === 'AbortError' && SHARE_CANCELLATION_MESSAGES.includes(error.message);
}
